import { render } from "./Version.vue?vue&type=template&id=0d966092&scoped=true"
import script from "./Version.vue?vue&type=script&setup=true&lang=js"
export * from "./Version.vue?vue&type=script&setup=true&lang=js"

import "./Version.vue?vue&type=style&index=0&id=0d966092&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d966092"],['__file',"src/components/app/sidebar/Version.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d966092"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d966092', __exports__)) {
    api.reload('0d966092', __exports__)
  }
  
  module.hot.accept("./Version.vue?vue&type=template&id=0d966092&scoped=true", () => {
    api.rerender('0d966092', render)
  })

}


export default __exports__